import React from 'react';
import styled from 'styled-components';


function Footer() {
  const Wrapper = styled.footer`
      color: white;
      background-color: black;
      border-top: 1px solid black;
      padding: 100px;
      a{
        color:white;
        text-decoration: none;
      }
  `;
  return (
    <Wrapper className="text-center">
      <span>
        © {new Date().getFullYear()}, Built with {` `}
        {` `}
        <a href="https://www.image-pit.com">IMAGEPIT</a>
      </span>
    </Wrapper>
  );
}

export default Footer;
